import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TitleManagerModalService {

  private selectedTitleManagerSubject = new BehaviorSubject<any>(null);
  public selectedTitleManager$ = this.selectedTitleManagerSubject.asObservable();

  constructor() { }

  setSelectedTitleManager(titleManager: any): void {
    this.selectedTitleManagerSubject.next(titleManager);
  }

  getSelectedTitleManager(): any | null {
    return this.selectedTitleManagerSubject.value;
  }

  clearSelectedTitleManager(): void {
    this.selectedTitleManagerSubject.next(null);
  }
}

